export class QuantitiesCostAmountValues {
  quantity: number = 0;
  unitCost: number = 0;
}
